export default {
  'home.banner.description':
    'Administre sua oficina pelo Ultracarweb de forma fácil e faça ela dar lucro.',
  'home.banner.button.signin': 'Acesse sua conta',
  'home.banner.button.freeTrial': 'Teste grátis',
};
